import React, { useState } from "react";
import { Send_SEF_Template_Emails } from "../api/Send_SEF_Template_Email";
import Get_Email_Template from "../functions/Get_Email_Template";
import GetClientAddress from "../../../../../functions/GetClientAddress";
import { Send_SEF_Assign_Emails } from "../api/Send_SEF_Assign_Emails";

function SEFEmail({ Attendee, setAttendee, id, logout }) {
  //handle email stuff
  const [textAreaValue, setTextAreaValue] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");

  const handleTextAreaChange = (e) => {
    setTextAreaValue(e.target.value);
  };

  const handleDropdownChange = (e) => {
    setDropdownValue(e.target.value);
  };

  function handleSendEmail() {
    let Arr_Emails = [];
    const Contacts = Attendee.Contacts || [];
    console.log("Contacts");
    console.log(Contacts);
    const AttendeeEmail = Contacts.find(
      (contact) => contact.Person === "Attendee"
    );
    const ParentEmail = Contacts.find((contact) => contact.Person === "Parent");

    if (AttendeeEmail || ParentEmail) {
      Arr_Emails = [AttendeeEmail.Email, ParentEmail.Email].filter(
        (contact) => contact
      );
    } else {
      console.log("Customer without Attendee or Parent");
      window.alert("No Attendee or Parent Emails Availible");
      return;
    }
    console.log("Arr_Emails");
    console.log(Arr_Emails);

    let Str_Student_Name =
      (Attendee.BasicInfo?.First_Name || "") +
      " " +
      (Attendee.BasicInfo?.Last_Name || "");
    let Str_SEFLink =
      GetClientAddress() +
      `Student/login/${Attendee._id}/${Attendee?.MetaData?.Password}`;
    const template = Get_Email_Template(
      dropdownValue,
      Arr_Emails,
      Str_Student_Name,
      Str_SEFLink,
      textAreaValue
    );
    const ECtemplate = Get_Email_Template(
      dropdownValue,
      Arr_Emails,
      Str_Student_Name,
      "",
      textAreaValue
    );

    let newDoc = {
      DateTime: new Date().toISOString(),
      Note: "SEF Template Email Sent: " + dropdownValue + ", " + textAreaValue,
      Staff_ID: localStorage.getItem("_id"),
    };

    let staffAssignEmail = "";
    if (dropdownValue === "Assign Helen") {
      staffAssignEmail = "helen@investin.org";
    } else if (dropdownValue === "Assign Hannah") {
      staffAssignEmail = "hannah@investin.org";
    } else if (dropdownValue === "Admin Updates") {
      staffAssignEmail = localStorage.getItem("Username") || "";
    } else if (dropdownValue === "Parent Callback Requested") {
      staffAssignEmail = localStorage.getItem("Username") || "";
    }

    if (template === undefined) {
      console.log("Template Not Found");
    } else {
      console.log("Sending email with template:", template);
      if (
        dropdownValue === "Assign Helen" ||
        dropdownValue === "Assign Hannah" ||
        dropdownValue === "Admin Updates" ||
        dropdownValue === "Parent Callback Requested"
      ) {
        Send_SEF_Assign_Emails(
          template,
          dropdownValue,
          newDoc,
          id,
          staffAssignEmail,
          Attendee,
          logout
        );
      } else {
        Send_SEF_Template_Emails(
          template,
          ECtemplate,
          Arr_Emails,
          newDoc,
          id,
          Attendee,
          logout
        );
      }
    }
  }

  let Arr_Templates = [
    { Template: "Phone Number Repeat" },
    { Template: "Photo Incorrect" },
    { Template: "Language Cert Missing" },
    { Template: "General Contact Details" },
    { Template: "Misc Other" },
    { Template: "Address Required" },
    { Template: "Medication Info" },
    { Template: "Mental Health Concerns" },
    { Template: "Physical Health Concerns" },
    { Template: "Disability Mobility Support" },
    { Template: "SEND Support" },
    { Template: "Assign Helen" },
    { Template: "Assign Hannah" },
    { Template: "Admin Updates" },
    { Template: "Parent Callback Requested" },
    { Template: "Photo Incorrect" },
    //{ Template: "XXXXXXXXXXX", IntroText: "None" },
  ];

  let seeTemplate = Get_Email_Template(
    dropdownValue,
    ["Emails"],
    Attendee.BasicInfo?.First_Name || "",
    "SEF_LINK_AUTO_GOES_HERE",
    textAreaValue && textAreaValue.length > 0
      ? textAreaValue
      : "YOUR_TEXT_GOES_HERE"
  );
  console.log("seeTemplate");
  console.log(seeTemplate);

  return (
    <>
      <div style={{ width: "100%", maxHeight: "100px", overflowY: "auto" }}>
        <p>
          <b>{seeTemplate.Subject_Line ? seeTemplate.Subject_Line : ""}</b>
          <br></br>
          {seeTemplate.BODY_TEXT_1 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_2 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_3 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_4 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_5 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_6 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_7 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_8 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_9 || ""}
          <br></br>
          {seeTemplate.BODY_TEXT_10 || ""}
        </p>
      </div>
      <textarea
        className="text-area"
        value={textAreaValue}
        onChange={handleTextAreaChange}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          width: "100%",
          margin: "0px",
          maxHeight: "30px",
        }}
      >
        <select
          className="dropdown"
          value={dropdownValue}
          onChange={handleDropdownChange}
          style={{ width: "45%" }}
        >
          <option value="">Select a template</option>
          {Arr_Templates.map((Obj_Template) => (
            <option key={Obj_Template.Template} value={Obj_Template.Template}>
              {Obj_Template.Template}
            </option>
          ))}
        </select>
        <button
          onClick={handleSendEmail}
          disabled={
            dropdownValue === "" ||
            dropdownValue === undefined ||
            dropdownValue === null
          }
          style={{ width: "45%" }}
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default SEFEmail;
